import { render, staticRenderFns } from "./activityFeedbackForm.html?vue&type=template&id=4bb37937&external"
import script from "./activityFeedbackForm.vue?vue&type=script&lang=js"
export * from "./activityFeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./activityFeedbackForm.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports